import _objectSpread from "/Users/xudong/bs_workspace/RuoYi-Vue/hss_-warning_-h5/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import { provinces } from './hospital.js';
import FormBox from '../../components/FormBox';
import CheckBook from '../../components/CheckBook';
import { imageLoad, kfltApi } from '../../api/myApi.js';
import dayjs from 'dayjs';
import { Toast } from 'vant';
export default {
  name: 'Home',
  components: {
    FormBox: FormBox,
    CheckBook: CheckBook
  },
  data: function data() {
    return {
      minDate: new Date(),
      // 设置为当前时间
      provinces: provinces,
      checked: false,
      data: {
        age: '',
        uploader: [],
        appointmentTime: ''
      },
      isIpt: true,
      hospitalList: [],
      showPicker: false,
      images: [],
      rules: {
        age: [{
          required: true,
          message: '请输入年龄',
          trigger: 'blur'
        }],
        region: [{
          required: true,
          message: '请选择地区',
          trigger: 'change'
        }],
        hospital: [{
          required: true,
          message: '请选择医院',
          trigger: 'change'
        }],
        appointmentTime: [{
          required: true,
          message: '请选择预约时间',
          trigger: 'change'
        }],
        uploader: [{
          required: true,
          message: '请选择病例',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    change: function change(val) {
      var _provinces$find;
      this.hospitalList = (_provinces$find = provinces.find(function (item) {
        return item.name === val[0];
      })) === null || _provinces$find === void 0 || (_provinces$find = _provinces$find.cities.find(function (item) {
        return item.name === val[1];
      })) === null || _provinces$find === void 0 ? void 0 : _provinces$find.hospitals;
    },
    onConfirm: function onConfirm(time) {
      var _this = this;
      var now = dayjs(time);
      this.data.appointmentTime = now.format('YYYY-MM-DD HH:mm:ss');
      this.$nextTick(function () {
        _this.$refs.form.validateField('appointmentTime'); // 手动触发验证
        _this.showPicker = false;
      });
    },
    inspectBtn: function inspectBtn(topData, isD) {
      this.isIpt = isD;
      this.data = _objectSpread(_objectSpread({}, this.data), topData);
    },
    afterReadAvatar: function afterReadAvatar(file) {
      var _this2 = this;
      var formData = new FormData();
      formData.append('file', file.file);
      imageLoad(formData).then(function (res) {
        _this2.images.push(res.url);
      });
    },
    onSubmit: function onSubmit(formName) {
      var _this3 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          //if (!this.checked) return Toast.fail('请先阅读并知晓《客户告知书》')
          kfltApi(_objectSpread(_objectSpread({}, _this3.data), {}, {
            medicalRecordFile: _this3.images.join(','),
            region: _this3.data.region[0],
            serviceType: '1'
          })).then(function (res) {
            Toast.success(res.msg);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};